/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Property } from 'csstype';
import { getStylist } from 'src/core/themes/luisStylist';

const { styleDiv } = getStylist('TestBladeHeader');

export const TestBladeHeader = styleDiv('TestBladeHeader', theme => ({
    display: 'flex',
    alignItems: 'center',
    height: 32,
    fontWeight: theme.headerFontWeight as Property.FontWeight,
    fontSize: theme.headerFontSize,
    $nest: {
        '& *': {
            fontWeight: theme.headerFontWeight as Property.FontWeight
        }
    }
}));
